export default __webpack_public_path__ + "static/media/0c0528030c884838.94a6ad4e8c932f480dc1f2720e0e9871.svg";